import { FullHeightCalculatorHOC, SubMenuRightContent, TopMenu } from 'common-js/components';
import { type FC, type ReactNode } from 'react';
import { type RouteComponentProps } from 'react-router';
import BaseLayout from './BaseLayout';

interface LayoutWelcomeProps extends RouteComponentProps<{}, RouterQueryParams> {
  children?: ReactNode;
}

const LayoutWelcome: FC<LayoutWelcomeProps> = ({ children, ...rest }) => (
  <BaseLayout layoutName="welcome" {...rest}>
    <TopMenu rightContent={<SubMenuRightContent />} />
    <FullHeightCalculatorHOC accountForDrawer>{children}</FullHeightCalculatorHOC>
  </BaseLayout>
);

export default LayoutWelcome;
